import React, { Component } from "react";
import theme from "css/themes/homePage/footer.css";
import EmailCollector from "../util/email-collector";

export default class ReadyToGrow extends Component {
  render() {
    return (
      <div className={theme.readyToGrow}>
        <div className={theme.container}>
          <p className={theme.title}>Ready to grow?</p>
        </div>
        <div className={theme.container}>
          <img alt="emailgrowth" src="/images/login/homepage/shared/mail-and-running-man.svg" />
          <div className={theme.middle}>
            <div className={theme.describe}>Apply Now to Get Access.</div>
            <EmailCollector buttonText="Apply Now" located="Footer" />
          </div>
          <img alt="analytics" src="/images/login/homepage/shared/analytics-symbol.svg" />
        </div>
      </div>
    );
  }
}
